export default [
  {
    text: '',
    value: 'data-table-expand',
    order: -1,
    sortable: false,
    hidable: false,
    hidden: false,
    width: '48px',
  },
  {
    text: 'Analysis No.',
    value: 'friendlyId',
    order: 1,
    sortable: true,
    hidable: false,
    hidden: false,
    width: '180px',
  },
  {
    order: 2,
    text: 'Tag ID',
    value: 'name',
    sortable: true,
    width: 250,
  },
  {
    text: 'Anomaly Count',
    value: 'anomalyCount',
    order: 3,
    sortable: true,
    hidable: false,
    hidden: false,
    width: '150px',
  },

  {
    text: 'Title',
    value: 'title',
    sortable: true,
    width: 200,
  },
  {
    text: 'Area',
    value: 'area',
    sortable: true,
    width: 120,
  },
  {
    text: 'Ri',
    value: 'ri',
    sortable: true,
    width: 150,
  },

  {
    text: 'Status',
    value: 'status',
    sortable: true,
    width: 130,
  },
];
